/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function joinURL() {
  var url = arguments[0];
  for (var i = 1; i < arguments.length; ++i) {
    url = url.replace(/\/$/, '') + '/' + arguments[i].replace(/^\//, ''); //eslint-disable-line prefer-template
  }
  return url;
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isLocal;
/**
 * @param {string} path
 * @returns {boolean}
 */
function isLocal(path) {
  return (/^(https?:)?\/\/localhost($|[/:])/.test(path)
  );
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getQueryUtils;
/**
 * Get value of URL parameter by its name
 * @param {string} name
 * @param {string} query
 * @returns {string}
 */
function getParameterFromQuery(query, name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(query);
  return results && results[1] ? decodeURIComponent(results[1]).replace(/\+/g, ' ') : '';
}

/**
 * Get state of boolean URL parameter by its name
 * @param {string} name
 * @param {string} query
 * @returns {boolean}
 */
function isParameterTrueInQuery(query, name) {
  return getParameterFromQuery(query, name) === 'true';
}

function getQueryUtils(window) {
  return {
    getParameterFromQuery: getParameterFromQuery,
    isParameterTrueInQuery: isParameterTrueInQuery,
    getParameterByName: getParameterFromQuery.bind(null, window.location.search),
    isParameterTrue: isParameterTrueInQuery.bind(null, window.location.search)
  };
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bindPolyfill2 = __webpack_require__(5);

var _bindPolyfill3 = _interopRequireDefault(_bindPolyfill2);

var _isBot2 = __webpack_require__(6);

var _isBot3 = _interopRequireDefault(_isBot2);

var _isSuspectedBot2 = __webpack_require__(7);

var _isSuspectedBot3 = _interopRequireDefault(_isSuspectedBot2);

var _experiment = __webpack_require__(8);

var _PackagesUtil = __webpack_require__(9);

var _PackagesUtil2 = _interopRequireDefault(_PackagesUtil);

var _convertSiteModel2 = __webpack_require__(11);

var _convertSiteModel3 = _interopRequireDefault(_convertSiteModel2);

var _render2 = __webpack_require__(12);

var _render3 = _interopRequireDefault(_render2);

var _addExperimentsFromQuery = __webpack_require__(14);

var _addExperimentsFromQuery2 = _interopRequireDefault(_addExperimentsFromQuery);

var _applyPackagesCache = __webpack_require__(15);

var _applyPackagesCache2 = _interopRequireDefault(_applyPackagesCache);

var _getBaseVersion = __webpack_require__(16);

var _getFullRjsConfig = __webpack_require__(17);

var _getFullRjsConfig2 = _interopRequireDefault(_getFullRjsConfig);

var _utils = __webpack_require__(18);

var _getQueryUtils = __webpack_require__(2);

var _getQueryUtils2 = _interopRequireDefault(_getQueryUtils);

var _getSubdomain = __webpack_require__(19);

var _getSubdomain2 = _interopRequireDefault(_getSubdomain);

var _instruments2 = __webpack_require__(20);

var _instruments3 = _interopRequireDefault(_instruments2);

var _joinURL = __webpack_require__(0);

var _joinURL2 = _interopRequireDefault(_joinURL);

var _mobile = __webpack_require__(21);

var _mobile2 = _interopRequireDefault(_mobile);

var _overrideScriptsLocationMapFromQuery = __webpack_require__(22);

var _overrideScriptsLocationMapFromQuery2 = _interopRequireDefault(_overrideScriptsLocationMapFromQuery);

var _requirejs = __webpack_require__(24);

var _requirejs2 = _interopRequireDefault(_requirejs);

var _resourcePrefetch = __webpack_require__(25);

var _resourcePrefetch2 = _interopRequireDefault(_resourcePrefetch);

var _rjsConfig = __webpack_require__(26);

var _rjsConfig2 = _interopRequireDefault(_rjsConfig);

var _storageUtil = __webpack_require__(30);

var _storageUtil2 = _interopRequireDefault(_storageUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This should be before the Polyfill

(0, _bindPolyfill3.default)(); /* global window */
/* eslint prefer-template:0 */
/* eslint-disable sort-imports */

var isBot = (0, _isBot3.default)(window);
var isSuspectedBot = (0, _isSuspectedBot3.default)(window);

var options = __webpack_require__(31);
var _window = window,
    rendererModel = _window.rendererModel,
    publicModel = _window.publicModel,
    _window$serviceTopolo = _window.serviceTopology,
    serviceTopology = _window$serviceTopolo === undefined ? {} : _window$serviceTopolo;


window.persistent = (0, _storageUtil2.default)(window); // TODO: how is this used?
var queryUtil = (0, _getQueryUtils2.default)(window);
window.queryUtil = queryUtil;

// Preload scripts for caching
var prefetch = window.isPrefetchMode || window.location.pathname.indexOf('prefetch') > 0 || queryUtil.isParameterTrue('prefetch');

var experimentInst = (0, _experiment.experiment)(window);
var render = (0, _render3.default)(window, _requirejs2.default, prefetch, isBot, experimentInst);
var packagesUtil = new _PackagesUtil2.default(options.packages, window.location.search, options.bundles);
var getViewerRjsConfig = (0, _rjsConfig2.default)(window, options.versions, experimentInst);

var _instruments = (0, _instruments3.default)(window, _requirejs2.default, isBot, isSuspectedBot, prefetch, experimentInst),
    sendErrorOrQueue = _instruments.sendErrorOrQueue,
    instrument = _instruments.instrument;

var convertSiteModel = (0, _convertSiteModel3.default)(window, sendErrorOrQueue, queryUtil);
var isPreview = queryUtil.isParameterTrue('isEdited');
var hasPageIdInHash = window.location.hash && window.location.hash !== '#!';
var isServerSide = !(window.clientSideRender || isPreview);

if (isServerSide && hasPageIdInHash) {
  window.isServerSideWithHash = true;
  isServerSide = false;
}

var _window2 = window,
    _window2$wixBiSession = _window2.wixBiSession,
    wixBiSession = _window2$wixBiSession === undefined ? {} : _window2$wixBiSession;

window.wixBiSession = wixBiSession;
wixBiSession.mainLoaded = Date.now();
wixBiSession.et = 1;

serviceTopology.scriptsLocationMap = (0, _overrideScriptsLocationMapFromQuery2.default)(serviceTopology.scriptsLocationMap, queryUtil.getParameterByName('scriptsLocations'));

rendererModel.runningExperiments = (0, _addExperimentsFromQuery2.default)(rendererModel.runningExperiments, queryUtil, 'viewer');

window.siteModel = convertSiteModel(rendererModel, publicModel, rendererModel.runningExperiments);
var _window3 = window,
    siteModel = _window3.siteModel;
var premiumFeatures = rendererModel.premiumFeatures;

var isPremium = !!premiumFeatures && premiumFeatures.indexOf('HasDomain') !== -1;

var pageInfo = publicModel && (0, _utils.getPageInfo)(window, publicModel.pageList, isPremium);

instrument(serviceTopology, wixBiSession, queryUtil, siteModel, pageInfo, isPremium);

if (publicModel && experimentInst.isOpen('checkRenderTime') && !options.disableCheckRenderTime) {
  if (Math.abs(Date.now() - publicModel.renderTime) > 2592e5) {
    wixBiSession.sendError({
      errorName: 'Error #2592e5',
      errorCode: 111026
    });
    throw new Error('Error #2592e5');
  }
}

if (window.karmaIntegration) {
  siteModel.documentServicesModel = siteModel.documentServicesModel || window.karmaIntegration.documentServicesModel;
  siteModel.wixapps = siteModel.wixapps || {};
  siteModel.wixapps.appbuilder = siteModel.wixapps.appbuilder || {};
  siteModel.wixapps.appbuilder.descriptor = siteModel.wixapps.appbuilder.descriptor || {};
  siteModel.wixapps.appbuilder.descriptor.applicationInstanceVersion = siteModel.wixapps.appbuilder.descriptor.applicationInstanceVersion || {};
}

var config = (0, _getFullRjsConfig2.default)('santa', window.santaBase, getViewerRjsConfig(serviceTopology), packagesUtil, serviceTopology);

if (!options.disablePackagesCache) {
  (0, _applyPackagesCache2.default)({
    proj: 'santa',
    paths: config.paths,
    manifest: options.manifest,
    version: options.version,
    scriptsDomainUrl: serviceTopology.scriptsDomainUrl
  });
}

siteModel.santaBase = config.baseUrl;
serviceTopology.staticServerFallbackUrl = serviceTopology.staticServerFallbackUrl || 'https://fallback.wix.com/';
siteModel.baseVersion = (0, _getBaseVersion.getBaseVersion)(siteModel.santaBase);
siteModel.santaBaseFallbackUrl = siteModel.baseVersion ? (0, _joinURL2.default)(serviceTopology.staticServerFallbackUrl, siteModel.baseVersion) : null;

_requirejs2.default.config(config);
(0, _experiment.defineExperiment)(window);

var mobileView = _mobile2.default.isMobileView(window, siteModel, queryUtil);

var contentCache = function contentCache() {}; //eslint-disable-line func-style
var dynamicModel = null;
if (publicModel && !queryUtil.isParameterTrue('prefetch')) {
  var resourcePrefetchOptions = {
    siteModel: siteModel,
    publicModel: publicModel,
    pageInfo: pageInfo,
    shouldTimeout: experimentInst.isOpen('pageRequestTimeout'),
    wixBiSession: wixBiSession,
    dynamicModel: dynamicModel,
    isServerSide: isServerSide,
    mobileView: mobileView,
    experiment: experimentInst,
    requirejs: _requirejs2.default
  };
  contentCache = (0, _resourcePrefetch2.default)(window, resourcePrefetchOptions);
}

try {
  window.document.domain = (0, _getSubdomain2.default)(window.document.domain);
} catch (e) {
  // empty
}

window.isPreview = queryUtil.isParameterTrue.bind(null, 'isEdited');
var isExternalPreview = rendererModel.previewMode;

render(isServerSide, isPreview, isExternalPreview, contentCache, queryUtil, siteModel, wixBiSession, mobileView, pageInfo, config);
wixBiSession.beat(4);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  if (!Function.prototype.bind) {
    Function.prototype.bind = function (object) {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      //eslint-disable-line no-extend-native
      return function () {
        for (var _len2 = arguments.length, a = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          a[_key2] = arguments[_key2];
        }

        return _this.apply(object, [].concat(args, a));
      };
    };
  }
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (window) {
  return (/bot|google|phantom|crawler|spider|crawling|headless|^mozilla\/4\.0$/i.test(window.navigator.userAgent)
  );
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (window) {
  if (!Function.prototype.bind) {
    return true;
  }

  var languages = window.navigator.languages;

  if (languages && languages.length === 0) {
    return true;
  }

  var stack = void 0;
  try {
    null[0]();
  } catch (e) {
    stack = e.stack;
  }

  if (stack && /ph\x61n\x74om|n\x6fde/i.test(stack)) {
    return true;
  }

  return false;
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function experiment(window) {
  var getRunningExperiments = function getRunningExperiments() {
    var rendererModel = window.rendererModel;

    if (rendererModel) {
      return rendererModel.runningExperiments;
    }
    var editorModel = window.editorModel;

    if (editorModel) {
      return editorModel.runningExperiments;
    }
  };

  var transformRunningExperiments = function transformRunningExperiments(runningExperiments) {
    return Object.keys(runningExperiments).reduce(function (acc, key) {
      acc[key.toLowerCase()] = runningExperiments[key];
      return acc;
    }, {});
  };

  var rawRunningExperiments = void 0;
  var transformedRunningExperiments = void 0;
  function getValue(name) {
    var runningExperiments = getRunningExperiments();
    if (rawRunningExperiments !== runningExperiments) {
      rawRunningExperiments = runningExperiments;
      transformedRunningExperiments = transformRunningExperiments(runningExperiments);
    }
    return transformedRunningExperiments[name.toLowerCase()];
  }

  var isOpen = function isOpen(name) {
    return getValue(name) === 'new';
  };

  function isMultiValueExperimentOpen(name) {
    var value = getValue(name);
    return value && value !== 'old';
  }

  return {
    getRunningExperiments: getRunningExperiments,
    isOpen: isOpen,
    getValue: getValue,
    isMultiValueExperimentOpen: isMultiValueExperimentOpen
  };
}

function defineExperiment(window) {
  if (window.define) {
    window.define('experiment', [], function () {
      return experiment(window);
    });
  }
}

exports.experiment = experiment;
exports.defineExperiment = defineExperiment;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _reduceQueryToObject = __webpack_require__(10);

var _reduceQueryToObject2 = _interopRequireDefault(_reduceQueryToObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {Array.<string>} packagesStructure
 * @param {string} query
 * @param {Array.<string>?} bundles
 * @constructor
 */
function PackagesUtil(packagesStructure, query) {
  var bundles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var queryParamsObject = (0, _reduceQueryToObject2.default)(query.replace(/^\?/, ''));

  /**
   * changes the config to load packages correctly, accounting the query
   * @param {Object} config
   * @returns {Object}
   */
  this.buildConfig = function (config) {
    var debug = (decodeURIComponent(queryParamsObject.debug) || '').split(',').filter(Boolean);

    if (debug.indexOf('all') !== -1) {
      var debuggableExternals = Object.keys(config.paths).filter(function (path) {
        return config.paths[path].source;
      });
      debug = packagesStructure.concat(debuggableExternals);
    }

    function isInDebug(i) {
      return debug.indexOf(i) !== -1;
    }

    //config.paths:
    Object.keys(config.paths).filter(function (k) {
      return _typeof(config.paths[k]) === 'object' && !Array.isArray(config.paths[k]);
    }).forEach(function (k) {
      config.paths[k] = config.paths[k][isInDebug(k) ? 'source' : 'min'];
    });

    //config.bundles:
    config.bundles = config.bundles || {};

    packagesStructure.filter(function (p) {
      return !isInDebug(p);
    }).filter(function (p) {
      return bundles.indexOf(p) === -1;
    }).forEach(function (pkg) {
      config.bundles[pkg] = pkg;
      config.paths[pkg] = 'packages-bin/' + pkg + '/' + pkg + '.min';
    });

    if (bundles && bundles.length > 0) {
      var bundleName = 'first-load';
      config.bundles[bundleName] = bundles;
      config.paths[bundleName] = 'packages-bin/' + bundleName + '/' + bundleName + '.min';
    }

    //config.packages:
    config.packages = config.packages || [];
    var projectPackages = packagesStructure.filter(isInDebug).map(function (name) {
      return {
        name: name,
        location: 'packages/' + name + '/src/main',
        main: name
      };
    });
    config.packages = config.packages.concat(projectPackages);

    return config;
  };
}

exports.default = PackagesUtil;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reduceQueryToObject;
/**
 *
 * @param {string} str
 * @param {string?} separator
 * @param {string?} equalizer
 * @returns {*}
 */
function reduceQueryToObject(str) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';
  var equalizer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '=';

  return (str || '').replace(/^\?/, '').split(separator).reduce(function (o, pairString) {
    var pair = pairString.split(equalizer);
    o[pair[0]] = pair[1];
    return o;
  }, {});
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (window, sendErrorOrQueue, queryUtil) {
  return function convertSiteModel(rendererModel, publicModel, runningExperiments) {
    function getPagesDataFromSiteAsJson(siteJson) {
      var initialPagesData = {
        masterPage: siteJson.masterPage
      };

      return siteJson.pages.reduce(function (accum, val) {
        accum[val.structure.id] = val;
        return accum;
      }, initialPagesData);
    }

    var siteModel = {
      publicModel: publicModel,
      urlFormatModel: rendererModel.urlFormatModel,
      routers: rendererModel.routers,
      serviceTopology: window.serviceTopology,
      santaBase: window.santaBase,
      configUrls: window.configUrls,
      rendererModel: rendererModel,
      componentGlobals: window.componentGlobals,
      serverAndClientRender: window.serverAndClientRender,
      adData: window.adData,
      mobileAdData: window.mobileAdData,
      googleAnalytics: window.googleAnalytics,
      ipAnonymization: window.ipAnonymization,
      googleRemarketing: window.googleRemarketing,
      facebookRemarketing: window.facebookRemarketing,
      yandexMetrika: window.yandexMetrika,
      wixData: window.wixData,
      wixapps: window.wixapps || getDefaultWixappsModel(),
      wixBiSession: window.wixBiSession,
      pagesData: window.pagesData,
      svgShapes: window.svgShapes,
      contactforms_metadata: {},
      renderFlags: {}
    };
    migrateTPAWidgetsToSemiNativeComponents(rendererModel.clientSpecMap, queryUtil, runningExperiments, window.serviceTopology, !!publicModel);
    siteModel.siteHeader = { id: siteModel.rendererModel.siteId, userId: siteModel.rendererModel.userId // required
    };siteModel.siteId = siteModel.rendererModel.siteId; // required
    siteModel.viewMode = siteModel.rendererModel.previewMode ? 'preview' : 'site'; // required
    if (window.siteAsJson) {
      movePageDataToMaster(window.siteAsJson, sendErrorOrQueue);
      siteModel.pagesData = getPagesDataFromSiteAsJson(window.siteAsJson);
    }
    var pagesPlatformApplications = getPagesPlatformApplications(siteModel);
    if (pagesPlatformApplications) {
      siteModel.pagesPlatformApplications = pagesPlatformApplications;
    }
    if (window.documentServicesModel) {
      siteModel.documentServicesModel = window.documentServicesModel;
    }
    return siteModel;
  };
};

var _isLocal = __webpack_require__(1);

var _isLocal2 = _interopRequireDefault(_isLocal);

var _joinURL = __webpack_require__(0);

var _joinURL2 = _interopRequireDefault(_joinURL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDefaultWixappsModel() {
  return { appbuilder: { metadata: { appbuilder_metadata: { requestedPartNames: [] } } } };
}

function getWixCodeAppDefId(clientSpecMap) {
  for (var spec in clientSpecMap) {
    if (clientSpecMap[spec].type === 'siteextension') {
      return clientSpecMap[spec].appDefinitionId.toString();
    }
  }
}

function hasAppWithAppDefId(clientSpecMap, appDefId) {
  for (var appId in clientSpecMap) {
    if (clientSpecMap.hasOwnProperty(appId) && clientSpecMap[appId].appDefinitionId === appDefId) {
      return true;
    }
  }
  return false;
}

function isGuid(appId) {
  var guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  return guidRegex.test(appId);
}

//compare appDefId with current and legacy wix code app def ids - needed for old automation site
function isLegacyWixCodeAppDefId(siteModel, appDefId) {
  return isGuid(appDefId) && !hasAppWithAppDefId(siteModel.rendererModel.clientSpecMap, appDefId);
}

function getPagesPlatformApplications(siteModel) {
  var wixCodeAppDefId = getWixCodeAppDefId(siteModel.rendererModel.clientSpecMap);
  var pagesPlatformApplications = siteModel.rendererModel.pagesPlatformApplications;
  var result = {};

  var _loop = function _loop(pageId) {
    if (pagesPlatformApplications.hasOwnProperty(pageId)) {
      pagesPlatformApplications[pageId].forEach(function (appDefId) {
        if (appDefId === wixCodeAppDefId || isLegacyWixCodeAppDefId(siteModel, appDefId)) {
          appDefId = 'wixCode';
        }
        result[appDefId] = result[appDefId] || {};
        result[appDefId][pageId] = true;
      });
    }
  };

  for (var pageId in pagesPlatformApplications) {
    _loop(pageId);
  }

  return result;
}

function _forEach(obj, cb) {
  if (obj instanceof Object) {
    Object.keys(obj).forEach(function (key) {
      cb(obj[key], key);
    });
  }
}

function migrateTPAWidgetsToSemiNativeComponents(clientSpecMap, queryUtil, runningExperiments, serviceTopology, isViewerMode) {
  if (isViewerMode && runningExperiments && runningExperiments.sv_migrateTpaToSemiNative === 'new') {
    var scriptsLocation = serviceTopology.scriptsDomainUrl;
    var semiNativeWidgetIds = queryUtil.getParameterByName('semiNativeWidgetId').split(',');
    var semiNativeAppUrl = queryUtil.getParameterByName('semiNativeUrl');
    if (semiNativeWidgetIds.length) {
      _forEach(clientSpecMap, function (spec) {
        var appWidgetWasMigrated = false;

        _forEach(spec.widgets, function (widget, widgetId) {
          var shouldMigrateWidgetToSemiNative = semiNativeWidgetIds.indexOf(widgetId) >= 0;
          if (shouldMigrateWidgetToSemiNative) {
            widget.componentFields = widget.componentFields || {};
            widget.componentFields.semiNative = true;
            appWidgetWasMigrated = true;
          }
        });

        if (appWidgetWasMigrated) {
          var getServiceUrl = _joinURL2.default.bind(null, scriptsLocation, 'services');
          var url = (0, _isLocal2.default)(semiNativeAppUrl) ? semiNativeAppUrl : getServiceUrl(semiNativeAppUrl);
          spec.appFields = spec.appFields || {};
          spec.appFields.platform = { viewerScriptUrl: url };
        }
      });
    }
  }
}

function movePageDataToMaster(siteAsJson, sendErrorOrQueue) {
  var masterData = siteAsJson.masterPage.data.document_data;

  function move(ref, to, from) {
    if (!get(from, ref)) {
      return;
    }

    if (!get(to, ref)) {
      set(to, ref, get(from, ref));
    }
    remove(from, ref);
  }

  function get(parentData, ref) {
    return ref && parentData[ref.replace('#', '')];
  }

  function set(parentData, ref, dataToSet) {
    if (ref) {
      parentData[ref.replace('#', '')] = dataToSet;
    }
  }

  function remove(parentData, ref) {
    if (ref) {
      delete parentData[ref.replace('#', '')];
    }
  }

  function moveMediaRef(masterPageDocumentData, pageData, mediaRef) {
    // Image or WixVideo
    var media = get(pageData, mediaRef);
    move(mediaRef, masterPageDocumentData, pageData);
    // Image
    move(media.posterImageRef, masterPageDocumentData, pageData);
  }

  siteAsJson.pages.forEach(function (page) {
    if (!page.structure) {
      return;
    }

    var pageData = page.data.document_data;
    var pageId = page.structure.id;
    var desktopBg = void 0;
    var mobileBg = void 0;

    // Pages or AppPages
    var pageItem = get(pageData, pageId);
    move(pageId, masterData, pageData);

    if (pageItem && pageItem.pageBackgrounds && pageItem.pageBackgrounds.desktop.ref) {
      // BackgroundImage or BackgroundMedia
      desktopBg = get(pageData, pageItem.pageBackgrounds.desktop.ref);
      mobileBg = get(pageData, pageItem.pageBackgrounds.mobile.ref);
      move(pageItem.pageBackgrounds.desktop.ref, masterData, pageData);
      move(pageItem.pageBackgrounds.mobile.ref, masterData, pageData);

      // const wixBiSession = window.wixBiSession || {} TODO: Indeed unused?

      //BackgroundMedia
      if (desktopBg) {
        if (desktopBg.mediaRef) {
          moveMediaRef(masterData, pageData, desktopBg.mediaRef);
        }
        //Image
        move(desktopBg.imageOverlay, masterData, pageData);
      } else {
        sendErrorOrQueue({
          errorName: 'MISSING_DESKTOP_BACKGROUND_ITEM',
          errorCode: 112001,
          severity: 30
        }, pageItem.id);
      }

      if (mobileBg) {
        if (mobileBg.mediaRef) {
          moveMediaRef(masterData, pageData, mobileBg.mediaRef);
        }
        //Image
        move(mobileBg.imageOverlay, masterData, pageData);
      } else {
        sendErrorOrQueue({
          errorName: 'MISSING_MOBILE_BACKGROUND_ITEM',
          errorCode: 112002,
          severity: 30
        }, pageItem.id);
      }
    }
  });
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (window, requirejs, prefetch, isBot, experiment) {
  var _window$performance = window.performance,
      performance = _window$performance === undefined ? {} : _window$performance;

  if (!performance.measure) {
    performance = {
      mark: function mark() {},
      measure: function measure() {}
    };
  }

  if (prefetch && window.define) {
    var dummy = function dummy() {
      return {};
    };
    var define = window.define;
    window.define = function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      for (var i = 0; i < args.length; ++i) {
        if (typeof args[i] === 'function') {
          args[i] = dummy;
        }
      }
      return define.apply(this, args);
    };
    window.define.amd = define.amd;
    var rjs = requirejs;
    window.requirejs = requirejs = function requirejs(dependencies) {
      return rjs.call(this, dependencies, dummy);
    };
  }

  function notifyParent(msg) {
    try {
      window.parent.postMessage(msg, '*');
    } catch (e) {
      //ignore
    }
  }

  notifyParent('santaStart');

  function render(isServerSide, isPreview, isExternalPreview, contentCache, queryUtil, siteModel, wixBiSession, mobileView, pageInfo, config) {
    var useDS = queryUtil.isParameterTrue('ds');
    var isQaAutomation = queryUtil.isParameterTrue('isqa');
    var isTpaIntegration = queryUtil.isParameterTrue('isTpaIntegration');
    var isWixCodeIntegration = queryUtil.isParameterTrue('isWixCodeIntegration');
    var isViewerIntegration = queryUtil.isParameterTrue('isViewerIntegration');

    var isProtectedPage = function () {
      if (isPreview || !pageInfo) {
        return false;
      }
      var currentPageId = pageInfo.pageId;

      if (!currentPageId) {
        return false;
      }
      var _siteModel$publicMode = siteModel.publicModel;
      _siteModel$publicMode = _siteModel$publicMode === undefined ? {} : _siteModel$publicMode;
      var _siteModel$publicMode2 = _siteModel$publicMode.pageList;
      _siteModel$publicMode2 = _siteModel$publicMode2 === undefined ? {} : _siteModel$publicMode2;
      var _siteModel$publicMode3 = _siteModel$publicMode2.pages,
          pages = _siteModel$publicMode3 === undefined ? [] : _siteModel$publicMode3;

      var pageData = pages.reduce(function (res, page) {
        return page.pageId === currentPageId ? page : res;
      }); //eslint-disable-line no-confusing-arrow
      return pageData ? !pageData.pageJsonFileName : false;
    }();

    function addConditionalDependencies(pkgs) {
      var map = siteModel.rendererModel.clientSpecMap;
      var mapKeys = Object.keys(map);
      var shouldLoadPackageFor = function shouldLoadPackageFor(applicationType) {
        return mapKeys.some(function (applicationId) {
          return map[applicationId].type === applicationType;
        });
      };

      function insert(p, marker) {
        var pos = p.indexOf(marker);

        for (var _len2 = arguments.length, extra = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          extra[_key2 - 2] = arguments[_key2];
        }

        if (pos !== -1) {
          p.splice.apply(p, [pos, 0].concat(extra));
        } else {
          p.push.apply(p, extra);
        }
      }

      var isWixDomain = function isWixDomain() {
        return window.location.hostname === 'www.wix.com';
      };

      var isWixSites = function isWixSites() {
        return isWixDomain() || queryUtil.isParameterTrue('iswixsite');
      };

      // We check that we have wixCodeModel, because if a site is published without Wix Code,
      // And then Wix Code is added and the site is saved, the metasite is "copied" to the
      // published site as well, showing as if there's Wix Code in the published site, although
      // there isn't
      var isWixCloud = function isWixCloud() {
        return shouldLoadPackageFor('siteextension') && !!siteModel.rendererModel.wixCodeModel;
      };

      function shouldLoadPackageForEComMigratedSite() {
        var _siteModel$publicMode4 = siteModel.publicModel;
        _siteModel$publicMode4 = _siteModel$publicMode4 === undefined ? {} : _siteModel$publicMode4;
        var _siteModel$publicMode5 = _siteModel$publicMode4.metaSiteFlags,
            metaSiteFlags = _siteModel$publicMode5 === undefined ? '' : _siteModel$publicMode5;

        return metaSiteFlags.indexOf('EComMigrated') >= 0;
      }

      function isQuickActionEnabled(quickActionName) {
        var _siteModel$rendererMo = siteModel.rendererModel.siteMetaData;
        _siteModel$rendererMo = _siteModel$rendererMo === undefined ? {} : _siteModel$rendererMo;
        var _siteModel$rendererMo2 = _siteModel$rendererMo.quickActions;
        _siteModel$rendererMo2 = _siteModel$rendererMo2 === undefined ? {} : _siteModel$rendererMo2;
        var _siteModel$rendererMo3 = _siteModel$rendererMo2.configuration,
            configuration = _siteModel$rendererMo3 === undefined ? {} : _siteModel$rendererMo3;

        return !!configuration[quickActionName];
      }

      var wixappsComps = ['container', 'textArea', 'matrixGallery', 'slideShowGallery', 'comboBoxInput', 'dialogs'];

      if (!experiment.isOpen('selectiveWixapps')) {
        if (isPreview || shouldLoadPackageFor('wixapps') || shouldLoadPackageFor('ecommerce') || shouldLoadPackageForEComMigratedSite()) {
          insert.apply(undefined, [pkgs, 'tpa', 'wixappsCore', 'wixappsClassics'].concat(wixappsComps, ['table', 'messageView']));
        }
        if (isPreview || shouldLoadPackageFor('appbuilder')) {
          insert.apply(undefined, [pkgs, 'tpa', 'wixappsCore', 'wixappsBuilder'].concat(wixappsComps));
        }
      }

      if (useDS || isPreview) {
        pkgs.push('documentServices', 'documentServicesSchemas');
      }
      if (isPreview) {
        pkgs.push('immutable');
      }

      if (isWixSites()) {
        pkgs.push('wixSites');
      }

      if (isWixCloud() || isPreview) {
        pkgs.push('wixCode');
      }

      if (typeof Promise === 'undefined' && window && !window.Promise) {
        pkgs.push('bluebird');
      }

      if (!experiment.isOpen('selectiveDialogs') || isProtectedPage || siteModel.rendererModel.passwordProtectedPages && siteModel.rendererModel.passwordProtectedPages.length) {
        pkgs.push('dialogs');
      }

      if (mobileView) {
        pkgs.push('tinyMenu', 'loginSocialBar', 'icon', 'svgShape');
        if (isQuickActionEnabled('quickActionsMenuEnabled')) {
          pkgs.push('mobileActionsMenu');
        }
      }

      if (!experiment.isOpen('sv_selectiveWixAds')) {
        pkgs.push('wixFreemiumBanner');
      }

      if (experiment.isOpen('sv_selectiveTranslations')) {
        pkgs.push('translations_en');
      } else {
        pkgs.push('translationsUtils');
      }

      return pkgs;
    }

    var handleRequireError = prefetch ? function () {} : function (pkgs) {
      return function (err) {
        if (err.requireType === 'define') {
          requirejs.onError(err);
          return;
        }
        if (!config.urlArgs) {
          if (err.requireModules) {
            err.requireModules.forEach(function (module) {
              requirejs.undef(module);
            });
          }
          config.urlArgs = 'c=' + Date.now();
          requirejs.config(config);
          var errClone = Object.keys(err).reduce(function (r, k) {
            r[k] = err[k];
            return r;
          }, {});
          errClone.message = err.message;
          errClone.stack = err.stack ? '' + err.stack : ''; //eslint-disable-line prefer-template
          requirejs(pkgs, function () {
            errClone.errn = 'REQUIREJS_RETRY_ERROR';
            errClone.errc = 111025;
            errClone.severity = 10;
            requirejs.onError(errClone);
          }, requirejs.onError);
        }
      };
    };

    var buildFunctionParametersObject = function buildFunctionParametersObject(pkgs, args) {
      return pkgs.reduce(function (result, pkg, index) {
        result[pkg] = args[index];
        return result;
      }, {});
    };

    var loadRequirements = function loadRequirements(pkgs, cb) {
      var loaded = cb ? function () {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        var p = buildFunctionParametersObject(pkgs, args);
        cb(p);
      } : function () {};

      if (queryUtil.getParameterByName('debug')) {
        requirejs(pkgs, loaded);
      } else {
        requirejs(pkgs, loaded, handleRequireError(pkgs));
      }
    };

    var load = function load(pkgs, cb) {
      wixBiSession.packagesLoaded = Date.now();

      /*
       * Require all needed packages (static + conditional)
       * Then do initial site render (or re-layout if it was rendered by the server)
       */
      function getAjaxHandler($, cookieUtils) {
        var ignore = {};

        var canUseCache = function canUseCache(_ref) {
          var url = _ref.url,
              type = _ref.type;
          return !ignore[url] && (!type || type.toUpperCase() === 'GET');
        };

        function addXSRFHeader(options) {
          var XSRFToken = cookieUtils.getCookie('XSRF-TOKEN');
          if (XSRFToken) {
            options.headers = options.headers || {};
            options.headers['X-XSRF-TOKEN'] = XSRFToken;
          }
        }

        function getHostname(url) {
          return url.match(/:\/\//) !== undefined ? url.split('/')[2] : url.split('/')[0];
        }

        return function (options) {
          if (options.cache !== false && canUseCache(options) && contentCache(options)) {
            return;
          }
          ignore[options.url] = true;

          if (options.type === 'POST' && getHostname(options.url) === 'editor.wix.com' && experiment.isOpen('xsrfHeaderOnPostRequests')) {
            addXSRFHeader(options);
          }
          $.ajax.apply($, arguments);
        };
      }

      loadRequirements([].concat(_toConsumableArray(pkgs), ['coreUtils', 'zepto']), function (p) {
        var ajaxHandler = getAjaxHandler(p.zepto, p.coreUtils.cookieUtils);
        p.coreUtils.ajaxLibrary.register(ajaxHandler);

        if (siteModel.wixData) {
          var siteStructureNode = window.document.getElementById('masterPage') || window.document.getElementById('SITE_STRUCTURE');
          siteModel.wixHtmlRaw = siteStructureNode.outerHTML;
          siteModel.wixAnchors = window.anchors || {};
          siteStructureNode.parentNode.removeChild(siteStructureNode);
        }

        siteModel.requestModel = {
          userAgent: window.navigator.userAgent,
          cookie: window.document.cookie,
          storage: p.coreUtils.storage(window)
        };
        siteModel.currentUrl = p.coreUtils.urlUtils.parseUrl(window.serverSideUrl || window.location.href);
        siteModel.forceMobileView = window.forceMobileView;

        cb(p, ajaxHandler);
      });
    };

    var loadWithIntegrationPackages = function loadWithIntegrationPackages(pkgs, cb) {
      var addIntegrationPackages = function addIntegrationPackages(packages) {
        if (isQaAutomation) {
          packages.push('qaAutomation');
        }
        if (isTpaIntegration) {
          packages.push('tpaIntegration', 'jasmine', 'jasmine-html');
        }
        if (isWixCodeIntegration) {
          packages.push('wixCodeIntegration', 'jasmine', 'jasmine-html');
        }
        if (isViewerIntegration) {
          packages.push('viewerIntegration', 'jasmine', 'jasmine-html');
        }
        return packages;
      };

      var initIntegrationPackages = function initIntegrationPackages(p) {
        var tpaIntegration = p.tpaIntegration,
            wixCodeIntegration = p.wixCodeIntegration,
            viewerIntegration = p.viewerIntegration;

        if (tpaIntegration) {
          tpaIntegration.init(window, p.core);
        }
        if (wixCodeIntegration) {
          wixCodeIntegration.init(window, p.core, p.wixCode, p.widgets, p.utils, p.tpa);
        }
        if (viewerIntegration) {
          viewerIntegration.init(window, p.core, p.utils);
        }
      };

      loadRequirements(addIntegrationPackages(pkgs), function (p) {
        window.Promise = window.Promise || p.bluebird;
        initIntegrationPackages(p);
        cb(p);
      });
    };

    function getClientSidePackages() {
      var clientSidePackages = ['lodash', 'zepto', 'coreUtilsLib', 'imageClientLib', 'coreUtils', 'core', 'layout', 'skins', 'react', 'TweenMax', 'components', 'mobx', 'mobx-react', 'color', 'remoteDOM', 'TimelineMax', 'animations', 'tpa', 'dataFixer', 'siteUtils', 'image', 'utils', 'xss', 'platformUtils', 'loggingUtils', 'santaProps', 'displayer', 'backgroundCommon', 'reactDOM', 'create-react-class', 'ScrollToPlugin', 'widgets', 'imageCommon', 'formCommon', 'textCommon', 'containerCommon', 'socialCommon', 'galleriesCommon', 'buttonCommon', 'compDesignUtils', 'skinExports', 'compUtils', 'mobileLayoutUtils', 'imageZoom', 'mobileLayoutUtils', 'pmrpc', 'tweenEngine', 'render'];
      return addConditionalDependencies(clientSidePackages);
    }

    function renderClientSide() {
      var clientSidePackages = getClientSidePackages();
      var shouldLoadWorkerDirectly = experiment.isOpen('wixCodeNoIframe') && Boolean(siteModel.publicModel);
      loadRequirements(['lodash', shouldLoadWorkerDirectly ? 'platformInit' : 'wixCodeInit'], function (_ref2) {
        var platformInit = _ref2.platformInit,
            _ref2$wixCodeInit = _ref2.wixCodeInit,
            wixCodeInit = _ref2$wixCodeInit === undefined ? platformInit : _ref2$wixCodeInit;

        performance.mark('code init start');

        var wixCodeAppApi = wixCodeInit.getAppApi();
        wixCodeInit.initMainR(wixCodeAppApi, undefined, siteModel, mobileView, queryUtil, undefined, isBot);
        var props = {
          wixCodeAppApi: wixCodeAppApi
        };
        var notify = notifyParent.bind(null, 'santaReady');

        var platformApps = wixCodeInit.appsUtils.getAppsBaseInfo({
          rendererModel: siteModel.rendererModel,
          clientSpecMap: siteModel.rendererModel.clientSpecMap,
          serviceTopology: siteModel.serviceTopology,
          viewerPlatformAppSources: queryUtil.getParameterByName('viewerPlatformAppSources'),
          santaBase: siteModel.santaBase
        });
        var anyPlatformApps = wixCodeInit.specMapUtils.getAppSpec(siteModel.rendererModel.clientSpecMap) || platformApps.length > 0;
        var corePlus = ['core'];
        if (isQaAutomation) {
          corePlus.push('qaAutomation');
        }
        if (anyPlatformApps) {
          corePlus.push('wixCode');
        }

        load(corePlus, function (pkgs, ajaxHandler) {
          performance.mark('prepare start');

          var requireAllComponents = !experiment.isOpen('selectiveDownload') || isPreview || useDS || isExternalPreview || !window.Promise;

          var core = pkgs.core,
              qaAutomation = pkgs.qaAutomation;

          if (qaAutomation) {
            qaAutomation.init(window, siteModel);
          }

          if (requireAllComponents) {
            loadRequirements(['components'].concat(core.requireCompCode.all()), function () {
              if (useDS || isPreview || isExternalPreview) {
                clientSidePackages.push('componentsPreviewLayer');
              }
              loadWithIntegrationPackages(clientSidePackages, function (p) {
                p.render.renderClientSide(p, ajaxHandler, siteModel, props, notify);
              });
            });
          } else {
            siteModel.selectiveCompDownload = true;
            var privates = core.renderer.createSitePrivatesEx(ajaxHandler, siteModel);
            var prepared = core.renderer.prepareSiteForRender(privates.displayedSiteData, privates.viewerPrivateServices, props);
            loadWithIntegrationPackages(clientSidePackages, function (p) {
              p.render.renderFromPrepared(p, privates, prepared, props, notify);
            });
          }
        });

        (0, _miniPackages2.default)(window, requirejs, isServerSide);

        performance.mark('code init finish');
        performance.measure('code init', 'code init start', 'code init finish');
      });

      loadRequirements(clientSidePackages);
    }

    function renderServerSide() {
      load(['lodash', 'coreUtilsLib', 'loggingUtils', 'siteUtils', 'experiment', 'mobileLayoutUtils', 'imageClientLib', 'skinExports', 'layout', 'warmup'].concat(_toConsumableArray(window.Promise ? [] : ['bluebird'])), function (loadedPackages) {
        window.Promise = window.Promise || loadedPackages.bluebird;

        loadedPackages.warmup.init(siteModel, function () {
          notifyParent('santaDidLayout');
          renderClientSide();
        });
      });
    }

    // Server side render state
    window.sssr = {};

    function callRender() {
      if (isServerSide) {
        renderServerSide();
      } else if (window.isServerSideWithHash) {
        window.document.addEventListener('DOMContentLoaded', renderClientSide);
      } else {
        renderClientSide();
      }
    }

    if ((0, _isLocal2.default)(window.santaBase) && queryUtil.getParameterByName('hot') !== 'false') {
      requirejs(['hot', 'zepto'], function (hot, $) {
        hot.init($);
        callRender();
      });
    } else {
      callRender();
    }
  }

  return render;
};

var _isLocal = __webpack_require__(1);

var _isLocal2 = _interopRequireDefault(_isLocal);

var _miniPackages = __webpack_require__(13);

var _miniPackages2 = _interopRequireDefault(_miniPackages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = miniPackages;
function miniPackages(window, requirejs, isServerSide) {
  var _window$location = window.location;
  _window$location = _window$location === undefined ? {} : _window$location;
  var hostname = _window$location.hostname;

  // Prefetch font CSS files
  // By marking them as media="none" their download is made non-blocking
  // (At least for WebKit / Blink browsers)
  // (WixThemeReact may remove this attribute)

  if (!isServerSide && hostname !== 'localhost') {
    requirejs(['lodash', 'utils'], function (_, utils) {
      function enableLink() {
        this.removeAttribute('media');
      }

      var document = window.document,
          documentType = window.rendererModel.siteInfo.documentType,
          serviceTopology = window.serviceTopology;

      var cssUrls = utils.fonts.fontUtils.getCssUrls(documentType, serviceTopology);
      _.forEach(cssUrls, function (url, id) {
        var link = document.createElement('link');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('href', url);
        link.setAttribute('media', 'none');
        link.setAttribute('id', 'font_' + id);
        link.addEventListener('load', enableLink, false);
        document.head.appendChild(link);
      });
    });
  }
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = addExperimentsFromQuery;
function addExperimentsFromQuery(runningExperiments, queryUtil, project) {
  var projValuePairRegex = new RegExp('^(' + project + ':)(.*)|(.*)$');

  var experiments = {};
  Object.keys(runningExperiments).forEach(function (key) {
    experiments[key] = runningExperiments[key];
  });

  var setPair = function setPair(_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    experiments[key] = value;
  };
  var getValueIfProj = function getValueIfProj(str) {
    return str.replace(projValuePairRegex, '$2');
  };

  var filterParamsForCurrProj = function filterParamsForCurrProj(paramValue) {
    return paramValue.split(';').map(getValueIfProj).filter(Boolean).join(',');
  };

  var setParamValues = function setParamValues(param, value) {
    var paramValue = queryUtil.getParameterByName(param);
    if (paramValue.indexOf(':') !== -1) {
      // Should be deprecated
      paramValue = filterParamsForCurrProj(paramValue);
    }
    paramValue.split(',').filter(Boolean).map(function (exp) {
      return [exp, value];
    }).forEach(setPair);
  };

  var setProjParamExperiments = function setProjParamExperiments() {
    queryUtil.getParameterByName(project + 'exp').split(',').filter(Boolean).map(function (exp) {
      return exp.split(':');
    }).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];

      return [key.toLowerCase(), value || 'new'];
    }).forEach(setPair);
  };

  //////////////////

  setParamValues('experiments', 'new');
  setParamValues('experimentsoff', 'old');
  setProjParamExperiments();

  return experiments;
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applyPackagesCache;
function applyPackagesCache(_ref) {
  var proj = _ref.proj,
      paths = _ref.paths,
      manifest = _ref.manifest,
      version = _ref.version,
      scriptsDomainUrl = _ref.scriptsDomainUrl;

  var validForCache = function validForCache(pkg) {
    return paths[pkg] && manifest[pkg] !== version;
  };
  var overrideFromCache = function overrideFromCache(pkg) {
    paths[pkg] = scriptsDomainUrl + "services/" + proj + "/" + manifest[pkg] + "/" + paths[pkg];
  };

  Object.keys(manifest).filter(validForCache).forEach(overrideFromCache);
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @param url
 * @returns {*|Array|{index: number, input: string}}
 */
function getBaseVersion(url) {
  var semverMatches = url.match(/\/(\d+\.\d+\.\d+)\/?$/);
  return semverMatches && semverMatches[1];
}

exports.getBaseVersion = getBaseVersion;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFullRjsConfig;

var _joinURL = __webpack_require__(0);

var _joinURL2 = _interopRequireDefault(_joinURL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isAddress = function isAddress(str) {
  return (/^(https?:)?\/\//.test(str)
  );
}; /* eslint curly:0 */

function getFullRjsConfig(name, base, config, packagesUtil, serviceTopology) {
  function getBaseUrl() {
    if (!base) return serviceTopology.scriptsLocationMap[name];
    if (isAddress(base)) return base;
    return (0, _joinURL2.default)(serviceTopology.scriptsDomainUrl, 'services', name, base);
  }

  config = packagesUtil.buildConfig(config);
  config.baseUrl = getBaseUrl();
  return config;
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @param window
 * @param pageList
 * @returns {*}
 */
function getPageInfo(window, pageList, isPremium) {
  if (!pageList) {
    return null;
  }
  var pages = pageList.pages || [];

  function getPageById(pageId) {
    for (var i = 0; i < pages.length; ++i) {
      if (pages[i].pageId === pageId) {
        return pages[i];
      }
    }
  }

  var hash = window.location.hash.split('/');
  var pageId = hash[1];
  if (pageId) {
    var page = getPageById(pageId);
    if (page) {
      return page;
    }
  }

  var pathname = window.location.pathname;
  if (pathname) {
    if (!isPremium) {
      var match = pathname.match(/\/.+\/([^/]+)$/);
      pathname = match && match[1];
    }

    if (pathname) {
      for (var i = 0; i < pages.length; ++i) {
        var pageUriSEO = pages[i].pageUriSEO;
        if (pageUriSEO) {
          var re = new RegExp('(^|/)' + pageUriSEO + '(/|$)');
          if (re.test(pathname)) {
            return pages[i];
          }
        }
      }
    }
  }

  return pageList.mainPageId && getPageById(pageList.mainPageId);
}

exports.getPageInfo = getPageInfo;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint prefer-template:0 */

module.exports = function getSubdomain(domain) {
  if (!domain) {
    return '';
  }
  var subDomain = domain.split('.');
  if (subDomain.length <= 2) {
    subDomain = domain;
  } else {
    var beforeLastPart = subDomain[subDomain.length - 2];
    var topLevelDomains = { com: true, org: true, net: true, edu: true, gov: true, mil: true, info: true, co: true, ac: true };
    if (topLevelDomains[beforeLastPart]) {
      subDomain = subDomain[subDomain.length - 3] + '.' + subDomain[subDomain.length - 2] + '.' + subDomain[subDomain.length - 1];
    } else {
      subDomain = subDomain[subDomain.length - 2] + '.' + subDomain[subDomain.length - 1];
    }
  }
  return subDomain;
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (window, requirejs, isBot, isSuspectedBot, prefetch, experiment) {
  var _window$location = window.location,
      location = _window$location === undefined ? {} : _window$location,
      _window$performance = window.performance,
      performance = _window$performance === undefined ? {} : _window$performance,
      XMLHttpRequest = window.XMLHttpRequest;
  var _location$href = location.href,
      href = _location$href === undefined ? '' : _location$href;


  var delayedErrors = [];
  function sendErrorOrQueue() {
    var wixBiSession = window.wixBiSession;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (wixBiSession && wixBiSession.sendError) {
      wixBiSession.sendError.apply(wixBiSession, args);
    } else {
      delayedErrors.push(args);
    }
  }

  function instrument(serviceTopology, wixBiSession, queryUtil, siteModel, pageInfo, isPremium) {
    wixBiSession.initialTimestamp = wixBiSession.initialTimestamp || wixBiSession.mainLoaded;
    wixBiSession.random = Math.random();

    var sampleRatioState = queryUtil.getParameterByName('sampleratio');
    var rendererModel = siteModel.rendererModel || window.rendererModel;
    var siteInfo = rendererModel.siteInfo;

    var base = (serviceTopology.biServerUrl || 'http://frog.wix.com').replace(/\/$/, '');

    function recordEt(et) {
      wixBiSession.et = et;
      if (performance.mark) {
        performance.mark('beat ' + et);
      }
    }
    wixBiSession.beat = recordEt;

    var param = function param(name, value) {
      return name + '=' + value;
    };
    var params = function params(pairs) {
      var p = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : param;
      return Object.keys(pairs).map(function (value) {
        return p(value, pairs[value]);
      }).join('&');
    };

    var biBool = function biBool(bool) {
      return Number(Boolean(bool));
    };

    function prepareMessage(evid, src, _ref) {
      var _ref$omit = _ref.omit,
          omit = _ref$omit === undefined ? {} : _ref$omit,
          map = _ref.map,
          _ref$pairs = _ref.pairs,
          pairs = _ref$pairs === undefined ? {} : _ref$pairs;

      pairs.evid = evid;
      pairs.src = src;

      if (!omit.pn) {
        pairs.pn = 1;
      }
      if (!omit.isp) {
        pairs.isp = biBool(isPremium);
      }
      if (!omit.url) {
        var url = href.replace(/^[^:]+:\/\/(www\.)?/i, '');
        pairs.url = encodeURIComponent(url.substring(0, 256));
      }

      if (!omit.v) {
        pairs.v = siteModel.baseVersion || 'unknown';
      }
      if (!omit.majorVer) {
        pairs.majorVer = window.clientSideRender ? 3 : 4;
      }
      if (!omit.ver && window.santaBase) {
        var sourceMatches = window.santaBase.match(/([\d\.]+)\/?$/);
        pairs.ver = sourceMatches && sourceMatches[1] || '';
      }

      if (!omit.dc && serviceTopology) {
        var serverName = serviceTopology.serverName;
        if (typeof serverName === 'string') {
          var parts = serverName.split('.');
          if (parts.length > 1) {
            pairs.dc = parts[1];
          }
        }
      }

      if (siteInfo && siteInfo.siteId) {
        pairs.sid = siteInfo.siteId;
      }
      if (rendererModel.metaSiteId) {
        pairs.msid = rendererModel.metaSiteId;
      }

      var siteHeader = siteModel.siteHeader || window.siteHeader;
      if (!omit.uuid && siteHeader && siteHeader.userId) {
        pairs.uuid = siteHeader.userId;
      }
      var publicModel = siteModel.publicModel;

      if (!omit.tsp && publicModel && publicModel.timeSincePublish) {
        pairs.tsp = publicModel.timeSincePublish;
      }
      if (wixBiSession.viewerSessionId) {
        pairs.vsi = wixBiSession.viewerSessionId;
      }

      if (!omit.ts && wixBiSession.initialTimestamp) {
        pairs.ts = Date.now() - wixBiSession.initialTimestamp;
      }

      var _param = map ? function (name, value) {
        return param(map[name] || name, value);
      } : param;
      return params(pairs, _param);
    }

    wixBiSession.sendBeacon = isBot && experiment.isOpen('ajaxForBI') ? function (url) {
      var r = new XMLHttpRequest();
      r.open('GET', url, true);
      r.send();
    } : function (url, useBeacon) {
      var sent = false;
      if (useBeacon && experiment.isOpen('useBeacon') && !isBot) {
        try {
          sent = window.navigator.sendBeacon(url);
        } catch (e) {
          /*Comment for Lint*/
        }
      }
      if (!sent) {
        new window.Image().src = url;
      }
    };

    function sendBI(endpoint, evid, code) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      var src = base + '/' + endpoint + '?c=' + Date.now() + '&';
      src += prepareMessage(evid, code, options);
      if (options.extra) {
        src += options.extra;
      }
      wixBiSession.sendBeacon(src, true);
    }

    wixBiSession.sendBI = function (endpoint, evid, code, extra, sampleRatio) {
      if (!sampleRatio || Math.floor(wixBiSession.random * sampleRatio) === 0) {
        sendBI(endpoint, evid, code, {
          omit: {
            pn: true,
            isp: true,
            ts: true,
            url: true,
            v: true,
            ver: true
          },
          map: {
            sid: 'did',
            dc: 'server',
            uuid: 'uid'
          },
          pairs: extra
        });
      }
    };

    var MAX_LIMIT = 4;

    var sendError = function sendError(name, errc) {
      for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        args[_key2 - 3] = arguments[_key2];
      }

      var sev = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 40;
      // eslint-disable-line func-style
      var visitor_id = wixBiSession.viewerSessionId;

      var pairs = {
        errn: encodeURIComponent(name),
        errc: errc,
        sev: sev,
        errscp: 'core',
        cat: 2,
        iss: 1,
        et: wixBiSession.et,
        visitor_id: visitor_id
      };

      var total = 0;
      pairs = args.reduce(function (result, arg, index) {
        if (index < MAX_LIMIT) {
          if (total + arg.length > 1024) {
            arg = arg.substring(0, Math.max(1024 - total, 32));
          }
          result['p' + (index + 1)] = encodeURIComponent(arg);
          total += result.length;
        }
        return result;
      }, pairs);

      sendBI('trg', 10, 44, {
        omit: {
          pn: true,
          isp: true,
          tsp: true,
          v: true,
          url: true,
          uuid: true
        },
        map: {
          sid: 'did',
          dc: 'server',
          ts: 'response_time'
        },
        pairs: pairs
      });
    };

    var prepareAndSendError = function prepareAndSendError(err, data) {
      var message = err.message,
          stack = err.stack,
          _err$requireModules = err.requireModules,
          requireModules = _err$requireModules === undefined ? [] : _err$requireModules,
          requireType = err.requireType;
      var errn = data.errn,
          errc = data.errc,
          severity = data.severity;

      var modules = requireModules && requireModules.join ? requireModules.join(';') : '';
      var what = stack ? '' + stack : message;
      sendError(errn, errc, severity, what, modules, href, requireType); // REQUIREJS_ERROR from packages/core/src/main/bi/errors.js
    };

    wixBiSession.sendError = function (err) {
      for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return sendError.apply(undefined, [err.errorName, err.errorCode, err.severity].concat(args));
    };

    delayedErrors.forEach(function (delayedError) {
      return wixBiSession.sendError.apply(wixBiSession, _toConsumableArray(delayedError));
    });
    delayedErrors = null;

    // Grow performance resource buffer as required
    var isDebug = queryUtil.getParameterByName('debug');
    if (performance.setResourceTimingBufferSize) {
      if ('onresourcetimingbufferfull' in performance) {
        performance.onresourcetimingbufferfull = function () {
          var maxSize = 150;
          return function () {
            maxSize *= 2;
            performance.setResourceTimingBufferSize(maxSize);
          };
        }();
      } else {
        performance.setResourceTimingBufferSize(isDebug ? 1000 : 300);
      }
    }

    var newrelic = window.newrelic;
    if (newrelic) {
      var shortUrl = href.replace(/^[^/]*\/\//, '');
      if (newrelic.setPageViewName) {
        newrelic.setPageViewName(shortUrl);
      }
      if (newrelic.setCustomAttribute) {
        newrelic.setCustomAttribute('url', shortUrl);
        if (siteInfo && siteInfo.siteId) {
          newrelic.setCustomAttribute('sid', siteInfo.siteId);
        }
        if (rendererModel.metaSiteId) {
          newrelic.setCustomAttribute('msid', rendererModel.metaSiteId);
        }

        if (experiment) {
          var runningExperiments = experiment.getRunningExperiments();
          if (runningExperiments) {
            var experiments = Object.keys(runningExperiments).filter(experiment.isMultiValueExperimentOpen).map(function (name) {
              var value = runningExperiments[name];
              return value !== 'new' ? name + '=' + value : name;
            }).join('][');
            if (experiments) {
              newrelic.setCustomAttribute('experiments', '[' + experiments + ']');
            }
          }
        }

        newrelic.setCustomAttribute('preview', biBool(rendererModel.previewMode));
        newrelic.setCustomAttribute('isPremium', isPremium);
        var siteHeader = siteModel.siteHeader || window.siteHeader;
        if (siteHeader && siteHeader.userId) {
          newrelic.setCustomAttribute('uuid', siteHeader.userId);
        }
        var publicModel = siteModel.publicModel;
        if (publicModel && publicModel.timeSincePublish) {
          newrelic.setCustomAttribute('timeSincePublish', publicModel.timeSincePublish);
        }
        if (wixBiSession.viewerSessionId) {
          newrelic.setCustomAttribute('vsi', wixBiSession.viewerSessionId);
        }
        newrelic.setCustomAttribute('debug', biBool(isDebug));
      }
    }

    if (prefetch) {
      wixBiSession.sendBI('ugc-viewer', 384, 42);
      return;
    }

    if (!wixBiSession.viewerSessionId || rendererModel.previewMode || queryUtil.isParameterTrue('suppressbi')) {
      return;
    }

    if (siteInfo.documentType !== 'Template') {
      (function validityBI() {
        var isTop = void 0;
        try {
          isTop = window.self === window.top;
        } catch (e) {
          isTop = false;
        }
        if (!isTop || isBot || isSuspectedBot) {
          wixBiSession.sendBI('ugc-viewer', 361, 42, {
            top: biBool(isTop),
            bot: biBool(isBot),
            sbot: biBool(isSuspectedBot)
          });
        }
      })();
    }

    if (!window.clientSideRender) {
      window.document.addEventListener('DOMContentLoaded', function () {
        wixBiSession.sendBI('ugc-viewer', 380, 42, { phase_name: 'did_load_dom_content', status: 1 });
      });
    }

    (function performanceBI() {
      var pairs = {};
      var navigation = performance.navigation,
          timing = performance.timing;

      if (timing) {
        var domainLookupStart = timing.domainLookupStart,
            domainLookupEnd = timing.domainLookupEnd,
            redirectStart = timing.redirectStart,
            redirectEnd = timing.redirectEnd,
            connectStart = timing.connectStart,
            connectEnd = timing.connectEnd,
            secureConnectionStart = timing.secureConnectionStart,
            requestStart = timing.requestStart,
            responseStart = timing.responseStart,
            responseEnd = timing.responseEnd;

        var dnsTime = domainLookupEnd - domainLookupStart;
        if (dnsTime >= 0) {
          pairs.dns_time = dnsTime;
        }
        var redirectTime = redirectEnd - redirectStart;
        if (redirectTime >= 0) {
          pairs.redirect_time = redirectTime;
        }
        var connectTime = connectEnd - connectStart;
        if (connectTime >= 0) {
          pairs.connect_time = connectTime;
        }
        if (secureConnectionStart > 0) {
          var sslTime = connectEnd - secureConnectionStart;
          pairs.ssl_time = sslTime;
        }
        var ttfbTime = responseStart - requestStart;
        if (ttfbTime >= 0) {
          pairs.ttfb_time = ttfbTime;
        }
        var responseTime = responseEnd - responseStart;
        if (responseTime >= 0) {
          pairs.response_time = responseTime;
        }
        var loadTime = timing.navigationStart || timing.fetchStart || domainLookupStart || connectStart;
        loadTime = wixBiSession.initialTimestamp - loadTime;
        if (loadTime >= 0) {
          pairs.load_time = loadTime;
        }
        if (pageInfo) {
          pairs.page_id = pageInfo.pageId;
        }
        pairs.is_ssl = biBool(location.protocol === 'https:');
      }
      if (navigation) {
        var redirectCount = navigation.redirectCount,
            type = navigation.type;

        if (type >= 0) {
          pairs.navigation_type = type;
        }
        if (redirectCount >= 0) {
          pairs.redirect_count = redirectCount;
        }
      }

      pairs.is_premium = biBool(isPremium);
      pairs.is_wixsite = biBool(siteInfo.documentType === 'WixSite');
      pairs.is_ssr = biBool(!window.clientSideRender);

      wixBiSession.sendBI('ugc-viewer', 351, 42, pairs);
    })();

    if (isDebug && sampleRatioState !== 'force') {
      return;
    }

    var siteType = function () {
      var BEAT_SITE_TYPES = ['No Site Type', 'WixSite', 'UGC', 'Template'];
      var documentType = siteInfo.documentType;
      var st = BEAT_SITE_TYPES.indexOf(documentType);
      return st !== -1 ? st : documentType;
    }();

    wixBiSession.maybeBot = isBot || isSuspectedBot;
    wixBiSession.beat = function (et, pid) {
      recordEt(et);
      var pairs = {
        isjp: biBool(wixBiSession.maybeBot),
        et: et,
        st: siteType
      };
      if (pid) {
        pairs.pid = pid;
      }
      sendBI('bt', 3, 29, {
        omit: {
          majorVer: true,
          tsp: true,
          ver: true
        },
        pairs: pairs
      });
    };

    var ignoreURLs = [/^chrome(\-extension)?\:/, /^file\:/, /^resource\:/, /\.net\//, /\.info\//, /\.ru\//, /google/, /facebook/, /dropbox/, /ad\-score/, /drivemac/, /shopping/, /datafast/, /shopcomp/, /vimeo/, /olark/];
    function ignoreError(where) {
      where = where.trim();
      if (!where) {
        return true;
      }
      for (var i = 0; i < ignoreURLs.length; ++i) {
        if (ignoreURLs[i].test(where)) {
          return true;
        }
      }
      return false;
    }

    if (!isSuspectedBot) {
      var firstTime = true;

      var onerror = window.onerror;

      window.onerror = function (errorMsg, url, line, column, err) {
        if (firstTime) {
          firstTime = false;
          var where = err && err.stack ? '' + err.stack : url;
          if (!ignoreError(where)) {
            sendError('JAVASCRIPT_ERROR', 111022, 40, errorMsg, where, href); // JAVASCRIPT_ERROR from packages/core/src/main/bi/errors.js
          }
        }
        if (onerror) {
          return onerror.apply(this, arguments);
        }
      };

      if (window.console) {
        var _console = console,
            error = _console.error;

        if (error) {
          console.error = function () {
            var stack = void 0;
            try {
              throw new Error('get stack');
            } catch (e) {
              stack = e.stack;
            }

            for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
              args[_key4] = arguments[_key4];
            }

            sendError.apply(undefined, ['CONSOLE_ERROR', 111023, 30, stack, href].concat(args)); // CONSOLE_ERROR from packages/core/src/main/bi/errors.js
            error.apply(this, args);
            console.error = error;
          };
        }
      }

      requirejs.onError = function (err) {
        if (!firstTime) {
          return;
        }
        firstTime = false;

        if (experiment.isOpen('sv_requireSplitError')) {
          if (err.requireType !== 'define') {
            prepareAndSendError(err, {
              errc: 111027,
              errn: 'REQUIREJS_FILE_DOWNLOAD_ERROR',
              severity: 40
            });
          } else {
            prepareAndSendError(err, {
              errc: 111028,
              errn: 'REQUIREJS_SCRIPT_ERROR',
              severity: 40
            });
          }
        }
        prepareAndSendError(err, {
          errc: 111024,
          errn: 'REQUIREJS_ERROR',
          severity: 40
        });
      };
    }
  }

  return {
    sendErrorOrQueue: sendErrorOrQueue,
    instrument: instrument
  };
};

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function isMobileDevice(window) {
  var userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
  var patternByDevice = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i;
  var patternByModel = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i; // eslint-disable-line max-len
  return patternByDevice.test(userAgent) || patternByModel.test(userAgent.substr(0, 4));
}

function isMobileView(window, siteModel, queryUtil) {
  return queryUtil.isParameterTrue('showmobileview') || // eslint-disable-line no-extra-parens
  isMobileDevice(window) && siteModel.rendererModel.siteMetaData && siteModel.rendererModel.siteMetaData.adaptiveMobileOn;
}

exports.default = { isMobileDevice: isMobileDevice, isMobileView: isMobileView };

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = overrideScriptsLocationMapFromQuery;

var _replaceUrlVersion = __webpack_require__(23);

var _replaceUrlVersion2 = _interopRequireDefault(_replaceUrlVersion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function overrideScriptsLocationMapFromQuery(scriptsLocationMap, overrideParam) {
  overrideParam.split(',').filter(Boolean).forEach(function (keyValueString) {
    var pair = keyValueString.split(':');
    var urlOverride = (0, _replaceUrlVersion2.default)(scriptsLocationMap[pair[0]], pair[1]);
    if (urlOverride && scriptsLocationMap[pair[0]] !== urlOverride) {
      scriptsLocationMap[pair[0]] = urlOverride;
    }
  });
  return scriptsLocationMap;
}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var bareSemver = /(\d)+\.(\d)+\.(\d)+/;
var onlyBareSemver = /^(\d)+\.(\d)+\.(\d)+$/;
var onlySha = /^[0-9a-f]{40}$/;

var validVersion = function validVersion(version) {
  return onlyBareSemver.test(version) || onlySha.test(version);
};

function replaceUrlVersion(url, version) {
  return url && validVersion(version) ? url.replace(bareSemver, version) : url;
}

exports.default = replaceUrlVersion;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = requirejs;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resourcePrefetch;

var _joinURL = __webpack_require__(0);

var _joinURL2 = _interopRequireDefault(_joinURL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resourcePrefetch(_ref, _ref2) {
  var document = _ref.document,
      XMLHttpRequest = _ref.XMLHttpRequest,
      Promise = _ref.Promise,
      santaBase = _ref.santaBase;
  var siteModel = _ref2.siteModel,
      publicModel = _ref2.publicModel,
      pageInfo = _ref2.pageInfo,
      shouldTimeout = _ref2.shouldTimeout,
      wixBiSession = _ref2.wixBiSession,
      dynamicModel = _ref2.dynamicModel,
      isServerSide = _ref2.isServerSide,
      mobileView = _ref2.mobileView,
      experiment = _ref2.experiment,
      requirejs = _ref2.requirejs;

  var cache = {};
  var pending = {};

  function _prefetch(url, options, pageId) {
    var r = new XMLHttpRequest();

    r.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        var cached = options.parse ? options.parse(r.response) : r.response;
        cache[url] = cached;
        pending[url].filter(function (op) {
          return op.success;
        }).forEach(function (op) {
          op.success(cached);
        });
      } else {
        this.onerror();
      }
    };
    r.onerror = function () {
      cache[url] = r;
      pending[url].filter(function (op) {
        return op.error;
      }).forEach(function (op) {
        op.error(r);
      });
    };
    r.onloadend = function () {
      delete pending[url];
    };

    r.open('GET', url, true);

    //Property timeout MUST be after .open() and before .send()
    //This is related to an issue with IE - https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/timeout
    if (shouldTimeout) {
      r.timeout = 2000;
      r.ontimeout = function () {
        if (pageId) {
          //beat 2 = 'reset' event
          wixBiSession.beat(2, pageId);
        }
      };
    }
    //Property timeout MUST be after .open() and before .send()

    if (options.accept) {
      r.setRequestHeader('Accept', options.accept);
    }

    r.send();
  }

  function prefetch(url, options, pageId) {
    if (url) {
      options = options || {};
      var cached = cache[url];
      if (cached) {
        if (options.success) {
          options.success(cached);
        }
      } else {
        var p = pending[url];
        if (!p) {
          pending[url] = p = [];
          _prefetch(url, options, pageId);
        }
        p.push(options);
      }
    }
  }

  function prefetchJSON(url, pageId) {
    prefetch(url, {
      accept: 'application/json',
      parse: function parse(response) {
        var json = null;
        try {
          json = JSON.parse(response);
          if (wixBiSession.et < 6) {
            prefetchComps(json);
            prefetchSvg(json.structure, response);
            presetBackground(json, pageId);
          }
        } catch (e) {
          // empty
        }
        return json;
      }
    }, pageId);
  }

  var pc = null;
  function prefetchComps(json) {
    if (Promise && json.structure && experiment.isOpen('prefetchComps')) {
      if (pc === null) {
        pc = new Promise(function (resolve) {
          requirejs(['coreUtils'], function (_ref3) {
            var prefetchComponents = _ref3.prefetchComponents;

            resolve(prefetchComponents);
          });
        });
      }
      pc.then(function (prefetchComponents) {
        var hasBlog = prefetchComponents(json, siteModel, mobileView);
        if (hasBlog) {
          prefetchJSON((0, _joinURL2.default)(santaBase, 'static/wixapps/apps/blog/descriptor.json'));
        }
      });
    }
  }

  var savedColor = void 0;
  var savedMap = void 0;
  function presetBackground(json, pageId) {
    if (experiment.isOpen('earlyBackground')) {
      var _json$data = json.data;
      _json$data = _json$data === undefined ? {} : _json$data;
      var document_data = _json$data.document_data,
          theme_data = _json$data.theme_data;

      if (theme_data) {
        var _theme_data$THEME_DAT = theme_data.THEME_DATA;
        _theme_data$THEME_DAT = _theme_data$THEME_DAT === undefined ? {} : _theme_data$THEME_DAT;
        var colorMap = _theme_data$THEME_DAT.color;

        savedMap = colorMap || savedMap;
      }
      if (document_data) {
        var _document_data$pageId = document_data[pageId];
        _document_data$pageId = _document_data$pageId === undefined ? {} : _document_data$pageId;
        var _document_data$pageId2 = _document_data$pageId.pageBackgrounds;
        _document_data$pageId2 = _document_data$pageId2 === undefined ? {} : _document_data$pageId2;
        var _document_data$pageId3 = _document_data$pageId2[mobileView ? 'mobile' : 'desktop'];
        _document_data$pageId3 = _document_data$pageId3 === undefined ? {} : _document_data$pageId3;
        var ref = _document_data$pageId3.ref;

        if (ref) {
          if (ref[0] === '#') {
            ref = ref.substring(1);
          }
          var _document_data$ref = document_data[ref];
          _document_data$ref = _document_data$ref === undefined ? {} : _document_data$ref;
          var color = _document_data$ref.color;

          savedColor = color || savedColor;
        }
      }
      if (savedColor) {
        if (savedColor.substring(0, 6) === 'color_' && savedMap) {
          savedColor = savedMap[savedColor.substring(6)];
        }
        if (savedColor && savedColor[0] === '#') {
          document.body.style.backgroundColor = savedColor;
        }
      }
    }
  }

  function shapeSkinNameToUrl(shapeSkinName) {
    function getSvgUri(version, svgHash, shapeName) {
      return svgHash + (version === 1 ? '_svgshape.v1.' + shapeName : '') + '.svg'; //eslint-disable-line prefer-template
    }

    var mediaRootUrl = siteModel.serviceTopology.mediaRootUrl;
    var partsArr = shapeSkinName.replace(/^.*\//, '').split('.');
    var version = partsArr[1] === 'v1' ? 1 : 2;
    var svgHash = partsArr[2].replace(/svg_/i, '');
    var svgName = partsArr[3];
    var svgUri = getSvgUri(version, svgHash, svgName);
    return (0, _joinURL2.default)(mediaRootUrl, 'shapes', svgUri);
  }

  var svgMap = {
    'skins.viewer.svgshape.SvgShapeDefaultSki': true
  };

  function prefetchSvg(structure, response) {
    if (structure && response.indexOf('"svg') !== -1) {
      var svgs = JSON.stringify(structure).match(/"skin"\s*:\s*"svg[^"]+"/g);
      if (svgs) {
        svgs.map(function (m) {
          m = m.match(/svg[^"]+/);
          return m && m[0];
        }).filter(function (svg) {
          if (!svg || svgMap[svg]) {
            return false;
          }
          svgMap[svg] = true;
          return true;
        }).map(shapeSkinNameToUrl).forEach(function (url) {
          prefetch(url);
        });
      }
    }
  }

  function getFirstUrl(pageJsonFileName) {
    if (pageJsonFileName) {
      var topology = publicModel.pageList.topology[0];
      return topology.baseUrl + topology.parts.replace('{filename}', pageJsonFileName);
    }
  }

  function getMasterPageFirstURL() {
    var _publicModel$pageList = publicModel.pageList,
        masterPageJsonFileName = _publicModel$pageList.masterPageJsonFileName,
        masterPage = _publicModel$pageList.masterPage;

    return getFirstUrl(masterPageJsonFileName) || masterPage && masterPage[0];
  }

  function getPageFirstURL() {
    return getFirstUrl(pageInfo.pageJsonFileName) || pageInfo.urls[0];
  }

  function shouldPrefetchPagesJsons() {
    return !isServerSide;
  }

  try {
    prefetchJSON(dynamicModel);

    if (shouldPrefetchPagesJsons()) {
      prefetchJSON(getMasterPageFirstURL(), 'masterPage');
      if (pageInfo) {
        prefetchJSON(getPageFirstURL(), pageInfo.pageId);
      }
    }
  } catch (e) {
    // empty
  }

  var cbs = [];

  function async(cb) {
    if (cbs.push(cb) === 1) {
      setTimeout(function () {
        var fs = cbs;
        cbs = [];
        fs.forEach(function (f) {
          f();
        });
      }, 0);
    }
  }

  return function (options) {
    var url = options.url;
    var cached = cache[url];
    if (cached) {
      async(function () {
        if (cached instanceof XMLHttpRequest) {
          options.error(cached);
        } else {
          options.success(cached);
        }
      });
    } else if (pending[url]) {
      pending[url].push(options);
    } else {
      return false;
    }
    return true;
  };
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (window, versions, experiment) {
  function getViewerRjsConfig(serviceTopology) {
    var local = (0, _isLocal2.default)((0, _getQueryUtils2.default)(window).getParameterByName('ReactSource'));
    var rr = (0, _getRjsConfig2.default)(versions, serviceTopology, local);

    if (!experiment) {
      rr.paths.experiment = 'js/plugins/experiment/experiment';
    }

    // generated
    rr.packages = ['tpaIntegration', 'wixCodeIntegration', 'viewerIntegration'].map(function (packageName) {
      return {
        name: packageName,
        main: packageName,
        location: (0, _getIntegrationPath2.default)(packageName, window.santaBase)
      };
    });

    return rr;
  }
  return getViewerRjsConfig;
};

var _getIntegrationPath = __webpack_require__(27);

var _getIntegrationPath2 = _interopRequireDefault(_getIntegrationPath);

var _getQueryUtils = __webpack_require__(2);

var _getQueryUtils2 = _interopRequireDefault(_getQueryUtils);

var _getRjsConfig = __webpack_require__(28);

var _getRjsConfig2 = _interopRequireDefault(_getRjsConfig);

var _isLocal = __webpack_require__(1);

var _isLocal2 = _interopRequireDefault(_isLocal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getIntegrationPath;

var _isLocal = __webpack_require__(1);

var _isLocal2 = _interopRequireDefault(_isLocal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var packageToFolder = {
  tpaIntegration: 'Santa-Integration-Protractor',
  wixCodeIntegration: 'js-wixcode-integration',
  viewerIntegration: 'viewer-integration',
  platformIntegrationEditor: 'js-platform-integration',
  tpaIntegrationEditor: 'Santa-Editor-Integration-Protractor' };

function getIntegrationPath(packageName, baseArtifact) {
  var integrationBasePath = (0, _isLocal2.default)(baseArtifact) ? '//localhost:4578' : '//s3.amazonaws.com/integration-tests-statics/' + packageToFolder[packageName] + '/SNAPSHOT/runners';

  return integrationBasePath + '/' + packageName + '/src/main';
}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getViewerRjsConfig;

var _rjsConfigUtils = __webpack_require__(29);

var _joinURL = __webpack_require__(0);

var _joinURL2 = _interopRequireDefault(_joinURL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function merge(a, b) {
  Object.keys(b).forEach(function (k) {
    a[k] = a[k] || b[k];
  });
}

var defaults = {
  'santa-core-utils': '1.113.0',
  zepto: '1.2.0',
  xss: '0.2.12',
  'create-react-class': '15.6.0-rc.0',
  'prop-types': '15.5.10',
  lodash: '4.7.0',
  react: '15.5.4',
  'react-dom': '15.5.4',
  bluebird: '2.9.4',
  'pm-rpc': '1.0.7',
  hammerjs: '2.0.8',
  // jsVendor: {
  mobx: '3.2.2',
  mobxReact: '4.2.2',
  tweenmax: '1.19.0'

  /**
   * @param {Object.<string, string>} versions
   * @param {*} serviceTopology
   * @param {boolean} local
   * @returns {*}
   */
};function getViewerRjsConfig(versions, serviceTopology, local) {
  var scriptsLocation = serviceTopology.scriptsDomainUrl;
  var platformSdkRoot = serviceTopology.scriptsLocationMap['js-platform-editor-sdk'];

  merge(versions, defaults);

  /**
   *  @type {function(pkg:string, path:string)}
   */
  var _unpkg = _rjsConfigUtils.unpkgOrNode.bind(null, versions, local);
  /**
   *  @type {function(pkg:string, min:string, debug:string)}
   */
  var _unpkgObj = _rjsConfigUtils.unpkgOrNodeObj.bind(null, versions, local);
  /**
   * @type {function(pkg:string, version:string, min:string)}
   */
  var _thirdParty = _rjsConfigUtils.vendorOrThirdParty.bind(null, scriptsLocation, local);
  /**
   * @type {function(pkg:string, version:string, min:string, debug:string)}
   */
  var _thirdObj = _rjsConfigUtils.vendorOrThirdPartyObj.bind(null, scriptsLocation, local);

  var paths = {
    // -------------- RUNTIME --------------------------------------------------------------
    //platformUtils: _unpkg('santa-platform-utils', versions.platformUtils,'/dist/platformUtils-bundle'),
    platformUtils: (0, _rjsConfigUtils.node)('santa-platform-utils', 'dist/platformUtils-bundle'),
    mobileCore: (0, _rjsConfigUtils.node)('santa-mobile-core', 'dist/mobileCore'),
    mobileLayoutUtils: (0, _rjsConfigUtils.node)('santa-mobile-core', 'dist/mobileLayoutUtils'),
    coreUtilsLib: _unpkg('santa-core-utils', 'dist/coreUtils'),
    imageClientLib: _unpkg('santa-core-utils', 'dist/imageClientApi'),
    wixImmutable: _unpkg('santa-core-utils', 'dist/wixImmutable'),
    lodash: _unpkg('lodash', 'lodash.min'),
    react: _unpkgObj('react', 'dist/react-with-addons.min', 'dist/react-with-addons'),
    reactDOM: _unpkgObj('react-dom', 'dist/react-dom.min', 'dist/react-dom'),
    reactDOMServer: _unpkgObj('react-dom', 'dist/react-dom-server.min', 'dist/react-dom-server'),
    'prop-types': _unpkgObj('prop-types', 'prop-types.min', 'prop-types'),
    'create-react-class': _unpkgObj('create-react-class', 'create-react-class.min', 'create-react-class'),
    zepto: _unpkgObj('zepto', 'dist/zepto.min', 'dist/zepto'),
    speakingurl: _thirdParty('speakingurl', '', 'speakingurl.min'),
    immutable: _thirdObj('immutable', '3.7.5', 'dist/immutable.min', 'dist/immutable'),
    mousetrap: _thirdParty('mousetrap', '1.4.6', 'mousetrap.min'),
    swfobject: _thirdParty('swfobject', '2.3.20130521', 'swfobject.min'),
    TweenMax: _thirdObj('tweenmax', versions.tweenmax, 'minified/TweenMax.min', 'uncompressed/TweenMax'),
    TweenLite: _thirdObj('tweenmax', versions.tweenmax, 'minified/TweenMax.min', 'uncompressed/TweenMax'),
    TimelineMax: _thirdObj('tweenmax', versions.tweenmax, 'minified/TweenMax.min', 'uncompressed/TweenMax'),
    ScrollToPlugin: _thirdObj('tweenmax', versions.tweenmax, 'minified/plugins/ScrollToPlugin.min', 'uncompressed/plugins/ScrollToPlugin'),
    DrawSVGPlugin: _thirdObj('tweenmax', versions.tweenmax, 'minified/plugins/DrawSVGPlugin.min', 'uncompressed/plugins/DrawSVGPlugin'),
    MorphSVGPlugin: _thirdObj('tweenmax', versions.tweenmax, 'minified/plugins/MorphSVGPlugin.min', 'uncompressed/plugins/MorphSVGPlugin'),
    Draggable: _thirdObj('tweenmax', versions.tweenmax, 'minified/utils/Draggable.min', 'uncompressed/utils/Draggable'),
    color: _thirdParty('color-convert', '0.2.0', 'color.min'),
    hammer: _unpkg('hammerjs', 'hammer.min'),
    bluebird: _unpkg('bluebird', 'js/browser/bluebird.min'),
    SoundManager: _thirdParty('soundmanager2', 'V2.97a.20150601', 'soundmanager2-nodebug-jsmin'),
    'date-fns': _thirdObj('date-fns', 'v1.3.0', 'date_fns.min', 'date_fns'),
    ajv: _thirdObj('ajv', '4.8.1', 'ajv.min', 'ajv.bundle'),
    'wix-fullstory-loader': (0, _rjsConfigUtils.node)('wix-fullstory-loader', 'dist/statics/app.bundle'),
    'data-capsule': _unpkg('data-capsule', 'dist/statics/frame-listener.bundle.min'),
    jsonpatch: 'js/vendor/json-patch/json-patch.umd',
    xss: _unpkg('xss', 'dist/xss.min'),
    immutableDiff: 'js/vendor/immutablejsdiff.min',
    pmrpc: _unpkg('pm-rpc', 'build/pm-rpc.min'),
    remoteDOM: _unpkg('@shimil/remote-dom', 'dist/local.min'),
    'ag-grid': _thirdObj('ag-grid', '6.2.1', 'dist/ag-grid.min', 'dist/ag-grid'),
    mobx: (0, _rjsConfigUtils.nodeObj)('mobx', 'lib/mobx.umd.min', 'lib/mobx.umd'),
    'mobx-react': (0, _rjsConfigUtils.nodeObj)('mobx-react', 'index.min', 'index'),
    coreMultilingual: (0, _rjsConfigUtils.node)('santa-multilingual', 'dist/languages'),
    // ------------- TESTING -------------------------------------------------------------------
    fake: 'js/plugins/fake/src/main/fake',
    definition: 'js/plugins/definition/src/main/definition',
    ReactProxy: 'js/vendor/ReactProxy',
    Squire: 'js/vendor/squire/Squire',
    jasmine: _thirdParty('jasmine', '2.1.3', 'jasmine'),
    'jasmine-html': _thirdParty('jasmine', '2.1.3', 'jasmine-html'),
    'jasmine-boot': _thirdParty('jasmine', '2.1.3', 'jasmine-boot'),
    // ------------- DEVELOPMENT ---------------------------------------------------------------
    io: 'https://cdnjs.cloudflare.com/ajax/libs/socket.io/1.4.0/socket.io.min',
    patcher: (0, _rjsConfigUtils.node)('santa-utils', 'common/hot/patcher'),
    hot: (0, _rjsConfigUtils.node)('santa-utils', 'common/hot/listener')
  };

  if (platformSdkRoot) {
    paths.platformAPI = { min: (0, _joinURL2.default)(platformSdkRoot, 'lib', 'platform-api.min'), source: (0, _joinURL2.default)(platformSdkRoot, 'lib', 'platform-api') };
  }

  return {
    //By default load any module IDs from js/lib
    baseUrl: '/',
    //except, if the module ID starts with "app",
    //load it from the js/app directory. paths
    //config is relative to the baseUrl, and
    //never includes a ".js" extension since
    //the paths config could be for a directory.
    paths: paths,
    map: {
      'mobx-react': {
        'react-dom': 'reactDOM'
      }
    },
    shim: {
      color: { exports: 'Color' },
      'jasmine-html': {
        deps: ['jasmine']
      },
      'jasmine-boot': {
        deps: ['jasmine', 'jasmine-html']
      },
      bluebird: { exports: 'bluebird' },
      SoundManager: { exports: 'soundManager' },
      ReactProxy: {
        deps: ['react'],
        exports: 'ReactProxy'
      },
      jsonpatch: { exports: 'jsonpatch' },
      xss: { exports: 'filterXSS' }
    },
    waitSeconds: 0
  };
}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nodeObj = exports.node = exports.third = exports.thirdObjUrl = exports.unpkgObj = exports.unpkg = exports.vendorOrThirdPartyObj = exports.vendorOrThirdParty = exports.unpkgOrNodeObj = exports.unpkgOrNode = undefined;

var _joinURL = __webpack_require__(0);

var _joinURL2 = _interopRequireDefault(_joinURL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * builds an unpkg url e.g.
 * https://static.parastorage.com/unpkg/lodash@4.17.4/lodash.min.js
 * https://unpkg.parastorage.com/wix-base-ui@2.192.0/dist/base-ui.js
 * @param {string} pkg
 * @param {string} v
 * @param {string} p
 * @returns {string}
 */
function unpkg(pkg, v, p) {
  return '//static.parastorage.com/unpkg/' + pkg + '@' + v + '/' + p;
  // return `//unpkg.parastorage.com/${pkg}@${v}/${p}`
}

/**
 * @param {string} pkg
 * @param {string} v
 * @param {string} min
 * @param {string} debug
 * @returns {{min: string, source: string}}
 */
function unpkgObj(pkg, v, min, debug) {
  return {
    min: unpkg(pkg, v, min),
    source: unpkg(pkg, v, debug)
  };
}

/**
 * @param {string} scriptLocation
 * @param {string} pkg
 * @param {string} v
 * @param {string} min
 * @param {string} debug
 * @returns {{min: url, source: url}}
 */
function thirdObjUrl(scriptLocation, pkg, v, min, debug) {
  return {
    min: third(scriptLocation, pkg, v, min),
    source: third(scriptLocation, pkg, v, debug)
  };
}

/**
 * @param {string} v
 * @param {string} name
 */
function check(v, name) {
  if (typeof v === 'undefined') {
    throw new Error('error ' + name + ' is \'' + v + '\'');
  }
}

/**
 * @param {string} scriptsLocation
 * @param {string} pkg
 * @param {string} version
 * @param {string} path
 * @returns {url}
 */
function third(scriptsLocation, pkg, version, path) {
  check(scriptsLocation, 'scriptsLocation');
  check(pkg, 'pkg');
  check(version, 'version');
  check(path, 'path');
  return (0, _joinURL2.default)(scriptsLocation, 'services', 'third-party', pkg, version, path);
}

// function isLocalSource(window, name) {
//   return isLocal(getQueryUtils(window).getParameterByName('ReactSource'))
// }

/**
 *
 * @param {string} m
 * @param {string} p
 * @returns {string}
 */
function node(m, p) {
  return 'node_modules/' + m + '/' + p;
}

/**
 * @param {*} versions
 * @param {boolean} local
 * @param {string} m
 * @param {string} p
 * @returns {string}
 */
function unpkgOrNode(versions, local, m, p) {
  return local ? node(m, p) : unpkg(m, versions[m], p);
}

/**
 * @param {*} versions
 * @param {boolean} local
 * @param {string} m
 * @param {string} min
 * @param {string} debug
 * @returns {{min: string, source: string}}
 */
function unpkgOrNodeObj(versions, local, m, min, debug) {
  return local ? nodeObj(m, min, debug) : unpkgObj(m, versions[m], min, debug);
}

/**
 * @param {string} scriptsLocation
 * @param {boolean} local
 * @param {string} pkg
 * @param {string} v
 * @param {string} p
 * @returns {url}
 */
function vendorOrThirdParty(scriptsLocation, local, pkg, v, p) {
  return local ? jsVendor(pkg, v, p) : third(scriptsLocation, pkg, v, p);
}

/**
 * @param {string} scriptsLocation
 * @param {boolean} local
 * @param {string} pkg
 * @param {string} v
 * @param min
 * @param debug
 * @returns {url}
 */
function vendorOrThirdPartyObj(scriptsLocation, local, pkg, v, min, debug) {
  return local ? jsVendor(pkg, v, min) : thirdObjUrl(scriptsLocation, pkg, v, min, debug);
}

/**
 * @param {string} pkg
 * @param {string} v
 * @param {string} p
 * @returns {url}
 */
function jsVendor(pkg, v, p) {
  return (0, _joinURL2.default)('js/third-party-modules', pkg, v, p);
}

/**
 * @param {string} m
 * @param {string} min
 * @param {string} debug
 * @returns {{min: string, source: string}}
 */
function nodeObj(m, min, debug) {
  return { min: node(m, min), source: node(m, debug) };
}

exports.unpkgOrNode = unpkgOrNode;
exports.unpkgOrNodeObj = unpkgOrNodeObj;
exports.vendorOrThirdParty = vendorOrThirdParty;
exports.vendorOrThirdPartyObj = vendorOrThirdPartyObj;
exports.unpkg = unpkg;
exports.unpkgObj = unpkgObj;
exports.thirdObjUrl = thirdObjUrl;
exports.third = third;
exports.node = node;
exports.nodeObj = nodeObj;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (window) {
  function isAvailable(name) {
    try {
      var unique = 'testStorage' + Date.now();
      var st = window[name];
      st.setItem(unique, unique);
      var value = st.getItem(unique);
      st.removeItem(unique);
      if (value !== unique) {
        throw 'not equal'; //eslint-disable-line no-throw-literal
      }
    } catch (e) {
      return false;
    }
    return true;
  }

  var storage = void 0;
  if (isAvailable('localStorage')) {
    storage = window.localStorage;
  } else if (isAvailable('sessionStorage')) {
    storage = window.sessionStorage;
  } else {
    storage = {
      setItem: function setItem() {},
      getItem: function getItem() {},
      removeItem: function removeItem() {}
    };
  }

  return {
    save: function save(key, value) {
      storage.setItem(key, value);
    },
    load: function load(key) {
      return storage.getItem(key);
    },
    remove: function remove(key) {
      storage.removeItem(key);
    }
  };
};

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {"version":"1.2648.6","manifest":{"a11yTestKit":"1.2537.15","adminLoginButton":"1.2537.15","animations":"1.2648.6","audioCommon":"1.2537.15","audioPlayer":"1.2648.6","backToTopButton":"1.2555.21","backgroundCommon":"1.2648.6","bgImageStrip":"1.2537.15","boxSlideShowSlide":"1.2537.15","buttonCommon":"1.2537.15","checkbox":"1.2537.15","comboBoxInput":"1.2648.6","compDesignUtils":"1.2537.15","compUtils":"1.2648.6","components":"1.2648.6","componentsPreviewLayer":"1.2648.6","contactForm":"1.2648.6","container":"1.2537.15","containerCommon":"1.2537.15","controller":"1.2555.21","core":"1.2648.6","coreUtils":"1.2648.6","dataFixer":"1.2648.6","datePicker":"1.2590.9","dateUtils":"1.2537.15","deadComponent":"1.2537.15","dialogs":"1.2648.6","displayer":"1.2648.6","disqusComments":"1.2537.15","documentMedia":"1.2537.15","documentServices":"1.2648.6","documentServicesSchemas":"1.2648.6","ebayItemsBySeller":"1.2648.6","editingRendererPlugins":"1.2537.15","exitMobileModeButton":"1.2537.15","facebookComments":"1.2537.15","facebookLike":"1.2537.15","facebookLikeBox":"1.2648.6","facebookShare":"1.2537.15","fileUploader":"1.2555.21","flashComponent":"1.2537.15","flickrBadgeWidget":"1.2537.15","formCommon":"1.2648.6","galleriesCommon":"1.2648.6","googleMap":"1.2555.21","gridComponent":"1.2648.6","htmlComponent":"1.2635.8","icon":"1.2620.10","image":"1.2648.6","imageButton":"1.2555.21","imageCommon":"1.2648.6","imageZoom":"1.2648.6","itunesButton":"1.2537.15","languageSelector":"1.2635.8","layout":"1.2648.6","linkBar":"1.2648.6","loggingUtils":"1.2648.6","loginButton":"1.2648.6","loginSocialBar":"1.2648.6","matrixGallery":"1.2648.6","mediaContainer":"1.2615.11","mediaControls":"1.2537.15","mediaPlayer":"1.2590.9","mediaRichText":"1.2648.6","memoizeAPI":"1.2537.15","messageView":"1.2555.21","mobileActionsMenu":"1.2635.8","paypalButton":"1.2537.15","pinItPinWidget":"1.2648.6","pinterestFollow":"1.2537.15","pinterestPinIt":"1.2648.6","platformInit":"1.2648.6","popupCloseTextButton":"1.2537.15","popupContainer":"1.2537.15","previewExtensionsCore":"1.2537.15","qaAutomation":"1.2648.6","quickActionBar":"1.2635.8","radioButton":"1.2537.15","radioGroup":"1.2537.15","render":"1.2635.8","repeater":"1.2590.9","rssButton":"1.2537.15","santaPreview":"1.2590.9","santaProps":"1.2648.6","semiNativeComponent":"1.2620.10","singleAudioPlayer":"1.2537.15","siteRegionContainer":"1.2537.15","siteUtils":"1.2648.6","skinExports":"1.2620.10","skins":"1.2648.6","skypeCallButton":"1.2648.6","slideShowGallery":"1.2648.6","socialCommon":"1.2635.8","soundCloudWidget":"1.2620.10","spotifyFollow":"1.2537.15","spotifyPlayer":"1.2537.15","stripColumnsContainer":"1.2648.6","stripContainer":"1.2537.15","stripSlideShow":"1.2590.9","stripSlideShowSlide":"1.2537.15","subscribeForm":"1.2648.6","svgCommon":"1.2537.15","svgShape":"1.2648.6","table":"1.2537.15","testUtils":"1.2648.6","textArea":"1.2537.15","textCommon":"1.2648.6","tinyMenu":"1.2648.6","tpa":"1.2648.6","tpaGalleries":"1.2648.6","translationsUtils":"1.2635.10","tweenEngine":"1.2648.6","twitterFeed":"1.2537.15","utils":"1.2648.6","vKShareButton":"1.2648.6","verticalAnchorsMenu":"1.2635.8","verticalMenu":"1.2648.6","wGooglePlusOne":"1.2537.15","wTwitterFollow":"1.2537.15","wTwitterTweet":"1.2537.15","warmup":"1.2648.6","widgets":"1.2648.6","wixCode":"1.2648.6","wixCodeInit":"1.2648.6","wixCodeSeo":"1.2648.6","wixFreemiumBanner":"1.2635.10","wixSites":"1.2648.6","wixappsBuilder":"1.2648.6","wixappsClassics":"1.2648.6","wixappsCore":"1.2648.6","youTubeSubscribeButton":"1.2648.6"},"versions":{"lodash":"4.17.4","react":"15.5.4","react-dom":"15.5.4","bluebird":"2.9.4","santa-core-utils":"1.232.0","pm-rpc":"1.0.7","zepto":"1.2.0","xss":"0.2.12","data-capsule":"1.0.69","create-react-class":"15.6.0-rc.0","prop-types":"15.5.0","@shimil/remote-dom":"5.0.0","mobx":"3.2.2","mobxReact":"4.2.2","tweenmax":"1.19.0"},"bundles":["animations","image","loggingUtils","displayer","backgroundCommon","widgets","imageCommon","formCommon","textCommon","containerCommon","socialCommon","galleriesCommon","buttonCommon","compDesignUtils","skinExports","imageZoom","tweenEngine","render"],"packages":["a11yTestKit","adminLoginButton","animations","audioCommon","audioPlayer","backToTopButton","backgroundCommon","bgImageStrip","boxSlideShowSlide","buttonCommon","checkbox","comboBoxInput","compDesignUtils","compUtils","components","componentsPreviewLayer","contactForm","container","containerCommon","controller","core","coreUtils","dataFixer","datePicker","dateUtils","deadComponent","dialogs","displayer","disqusComments","documentMedia","documentServices","documentServicesSchemas","ebayItemsBySeller","editingRendererPlugins","exitMobileModeButton","facebookComments","facebookLike","facebookLikeBox","facebookShare","fileUploader","flashComponent","flickrBadgeWidget","formCommon","galleriesCommon","googleMap","gridComponent","htmlComponent","icon","image","imageButton","imageCommon","imageZoom","itunesButton","languageSelector","layout","linkBar","loggingUtils","loginButton","loginSocialBar","matrixGallery","mediaContainer","mediaControls","mediaPlayer","mediaRichText","memoizeAPI","messageView","mobileActionsMenu","paypalButton","pinItPinWidget","pinterestFollow","pinterestPinIt","platformInit","popupCloseTextButton","popupContainer","previewExtensionsCore","qaAutomation","quickActionBar","radioButton","radioGroup","render","repeater","rssButton","santaPreview","santaProps","semiNativeComponent","singleAudioPlayer","siteRegionContainer","siteUtils","skinExports","skins","skypeCallButton","slideShowGallery","socialCommon","soundCloudWidget","spotifyFollow","spotifyPlayer","stripColumnsContainer","stripContainer","stripSlideShow","stripSlideShowSlide","subscribeForm","svgCommon","svgShape","table","testUtils","textArea","textCommon","tinyMenu","tpa","tpaGalleries","translationsUtils","tweenEngine","twitterFeed","utils","vKShareButton","verticalAnchorsMenu","verticalMenu","wGooglePlusOne","wTwitterFollow","wTwitterTweet","warmup","widgets","wixCode","wixCodeInit","wixCodeSeo","wixFreemiumBanner","wixSites","wixappsBuilder","wixappsClassics","wixappsCore","youTubeSubscribeButton"]}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main-r.min.js